import { useTranslation } from 'react-i18next';

import ErrorMessage from '@/components/shared/ErrorMessage';
import PendencyList from '@/components/student-dashboard/PendencyList';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { ExamPendency } from '@/data/hook/student-dashboard/useStudentExamPendency';

type StudentPendenciesSectionProps = {
  exam: ExamPendency;
  homeworkCount: number;
  nextLessonDate?: string;
  limit: number;
  error: unknown;
  className?: string;
};

export default function StudentPendenciesSection({
  exam,
  homeworkCount,
  nextLessonDate,
  limit,
  error,
  className,
}: StudentPendenciesSectionProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'studentDashboard.continuity.pendencies',
  });

  return (
    <ConditionalRenderer
      condition={!error}
      fallback={<ErrorMessage text={t('loadError')} className="h-24" />}
    >
      <PendencyList
        exam={exam}
        homeworkCount={homeworkCount}
        nextLessonDate={nextLessonDate}
        limit={limit}
        className={className}
      />
    </ConditionalRenderer>
  );
}
